const navLinks = [
    { title: `About me`, path: `#sign-up` },
    { title: `Relationships`, path: `#sign-up` },
    { title: `Requirements`, path: `#sign-up` },
    { title: `Users`, path: `#sign-up` },
    { title: `Sign Up`, path: `#sign-up` }
];

export default navLinks;
